import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiHttpService } from './api-http.service';
import { environment } from '../../environments/environment';
const { API_URLBLAZE } = environment;

@Injectable({
  providedIn: 'root'
})
export class UnblockService {

  constructor(private http: ApiHttpService) {}

  submitUnblockRequest(file: File | null, requestData: any): Observable<any> {
  const formData = new FormData();

  if (file) {
    formData.append('icon', file);
  }

  // JSON string matches DTO
  formData.append('request', JSON.stringify(requestData));

  return this.http.post(`${API_URLBLAZE}/user/unblock-request`, formData);
}


/// New method to fetch unblock requests list by userType
getUnblockRequests(userType: string): Observable<any> {
  return this.http.get(`${API_URLBLAZE}/user/getAll-unblock-requests`, {
    params: { userType }  // pass userType as query parameter
  });
}

  // Download initiator document(s) as ZIP
downloadInitiatorDocs(userId: string): Observable<Blob> {
  return this.http.get(`${API_URLBLAZE}/user/unblock-request/${userId}/download`, {
    responseType: 'blob'
  });
}


}
